import { render, staticRenderFns } from "./MenuExtItem.vue?vue&type=template&id=ed83c994&"
import script from "./MenuExtItem.vue?vue&type=script&lang=js&"
export * from "./MenuExtItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuExtItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VExpansionPanelHeader } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VProgressLinear})
